import React, {useEffect} from 'react';
import ArtGallery from '../sections/ArtGallery';
import Preloader from '../components/Preloader';
import Colab from '../sections/Colab';

const ArtGalleryImages = () => {
    useEffect(() => {
        window.scrollTo(0, 0); // Scroll to top
      }, []);
       

    return(
        <main className="main">
            <Preloader></Preloader>
            <Colab></Colab>
            <ArtGallery></ArtGallery>
        </main>    
    );
}

export default ArtGalleryImages;